import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import clsx from 'clsx';
import BaseTypography from '../Text/BaseTypography';
import { NotificationBadge } from '../UI/Badges';
import { SidebarItem, SidebarItemClasses } from './layoutPreviewTypes';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '24px',
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '-webkit-fill-available',
      alignItems: 'center',
      padding: theme.spacing(0, 0.5),
      borderRadius: theme.shape.borderRadius,
    },
    itemIcon: {
      fontSize: 8,
    },
    itemText: {
      marginLeft: theme.spacing(1),
      fontSize: 8,
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '72px',
      textOverflow: 'ellipsis',
    },
    itemTextWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    active: {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
);
interface SidebarItemPreviewProps {
  item: SidebarItem;
  classes: SidebarItemClasses;
}

export const SidebarItemPreview: React.FC<SidebarItemPreviewProps> = ({
  item,
  classes,
}) => {
  const defaultClasses = useStyles();
  const ItemIcon = item.icon;

  return (
    <div
      className={clsx(defaultClasses.root, classes.item, {
        [classes.itemActive || defaultClasses.active]: item.active,
      })}
    >
      <div className={defaultClasses.itemTextWrapper}>
        <ItemIcon className={defaultClasses.itemIcon} />
        <BaseTypography className={defaultClasses.itemText}>
          {item.title}
        </BaseTypography>
      </div>
      {item.notificationCount && (
        <NotificationBadge
          content={item.notificationCount}
          isSidebar
          isPreview
          previewClass={classes.notificationBadge}
        />
      )}
    </div>
  );
};
